/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserContentInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class UserContentApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'UserContents');
  }

  patchAttributes(personId: number, update: Partial<UserContentInterface>): Observable<UserContentInterface> {
    const path = `${personId}`;
    return this.patch(path, undefined, update);
  }
}
